import React from 'react';
import '../style/css/confirmationModal.css'
import utils from "../services/utils";
const ConfirmationDialog = ({ message, onConfirm, onCancel }) => {
    return (
        <div className="confirmation-dialog">
            <div className="confirmation-dialog-content">
                <p>{message}</p>
                <button onClick={onConfirm}>{utils.useLang('APPROVE')}</button>
                <button onClick={onCancel}>{utils.useLang('CANCEL')}</button>
            </div>
        </div>
    );
};

export default ConfirmationDialog;
